module.exports = __webpack_public_path__ + "static/media/moderate.1cfac8e0.svg";